import DesignBG from "./design_photo.jpg"
import MobileBG from "./mob_dev_photo.jpg"
import QaBG from "./qa_photo.jpg"
import StartupBG from "./startup_photo.jpg"
import TeamBG from "./team_photo.jpg"
import UiUxBG from "./ui_ux_photo.jpg"
import WebBG from "./web_dev_photo.jpg"

export { DesignBG, MobileBG, QaBG, StartupBG, TeamBG, UiUxBG, WebBG }
